module.exports = __webpack_public_path__ + "img/type_NORMAL.80965fcf.png";